import { useEffect, useState } from "react";

const useDynamicCSS = (hrefs) => {
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    const links = [];

    // Normalize input: make it always an array
    const cssFiles = Array.isArray(hrefs) ? hrefs : [hrefs];

    cssFiles.forEach((href, index) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.id = `dynamic-css-${index}-${href}`;
      document.head.appendChild(link);
      links.push(link);
    });

    let timer = setTimeout(() => {
      setLoader(true);
    }, 500);
    return () => {
      clearTimeout(timer);
      links.forEach((link) => {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
    };
  }, [hrefs]);

  return loader;
};

export default useDynamicCSS;
